import Swal from "sweetalert2"
import { removeDataAttributes } from "../../../functions/adapters/universal/removeDataAttributes"
import { getQueryOffers } from "../../../functions/shared/api/queries/getQueryOffers"
import { sendNotification } from "../../../functions/shared/notifications/sendNotification"
import { swalOptions } from "../../../functions/swalOptions"
import { ACCESS_KEY, urlAPI } from "../../../urls"
import { type AppDispatch, type RootState } from "../../store"
import { offerAdminViewStatuses } from "../../../constants"
import _ from "lodash"


export const setOfferStatus = (offerID: number, status?: string, data?: Record<string, any>, notify?: { rule: string, receiver: string }, slipLink?: string) => async (dispatch: AppDispatch, getState: () => RootState): Promise<any> => {
    try {
        if (status != null && ['Canceled', 'Rejected'].includes(status)) {
            const confirmationResult = await Swal.fire({
                ...swalOptions('warning'),
                title: 'Are you sure?',
                html: 'This offer will be canceled if you continue',
                showConfirmButton: true,
                confirmButtonText: 'Continue',
                showCancelButton: true,
                cancelButtonText: 'Go back'
            })
            if (!confirmationResult.isConfirmed) {
                return
            }
        }

        const jwt = window.localStorage.getItem(ACCESS_KEY) ?? ''
        const offer = removeDataAttributes(
            _.cloneDeep(
                _.find(getState().offers.offers, (offerItem: any) => offerItem.id === offerID) ?? {}
            )
        )
        offer.RejectReason = data?.RejectReason ?? null
        if (data?.Type != null) {
            offer.Type = [{
                ...(offer?.Type[0] ?? {}),
                ...((data.Type as any[])?.[0] ?? {})
            }]
        }
     
        if (status !== undefined) {
            offer.Statuses = [status]
        }

        offer.Notify = !offerAdminViewStatuses.includes(String(status)) ? notify?.receiver : null

        if (slipLink !== undefined) {
            offer.Type[0].DepositSlipLink = slipLink
        }

        if (data != null && data?.Documents?.length > 0) {
            offer.Documents = [...offer.Documents, ...data.Documents]
        }

        const bodyObject = {
            method: 'PUT',
            collection: 'offers',
            id: offerID,
            body: offer,
            query:  getQueryOffers()
        }

        const response = await fetch(`${urlAPI}`, {
            method: 'POST',
            body: JSON.stringify(bodyObject),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${jwt}`
            }
        })
        if (notify != null) {
            await sendNotification(new Date(new Date().getTime() + 10000),  offer.User.id, offer.id, notify?.rule, 'Offer - ' + String(status)) 
        }
        return await response.json()
    } catch (error) {
        console.log(error)
    }
}